export default __webpack_public_path__ + "static/20211202_151355-50d8a42d5845a6f476547c69f37e83f6.jpeg";